import React from 'react';

import BauxAEcheance from '../../components/Monitoring/BauxAEcheance';

function BauxAEcheanceView() {
  return (
    <BauxAEcheance />
  );
}

export default BauxAEcheanceView;
